/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Partner_Edit_Contract_Periods_FloorInputs */



/**
* | output |
* | --- |
* | "At least {count} months — that many have already begun." |
*
* @param {Partner_Edit_Contract_Periods_FloorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_edit_contract_periods_floor = /** @type {((inputs: Partner_Edit_Contract_Periods_FloorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Edit_Contract_Periods_FloorInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Mindestens ${i?.count} Monate — so viele haben bereits begonnen.`)
	return /** @type {LocalizedString} */ (`At least ${i?.count} months — that many have already begun.`)
});